import styled from '@emotion/styled';
import { Spin } from 'antd';
import { useMemo } from 'react';
import { useAsync } from 'react-use';
import { getSaleConvert } from 'services/api/dashboard';
import {
  last7days,
  momentDateRange2FetchParams,
  platformAll2Undefined,
  storeType2FetchParams,
} from '../../utils';
import ExtraNode from '../Filter/ExtraNode';
import FilterProvider from '../Filter/Provider';
import { useDashboardFilterContext } from '../Filter/useFilter';
import TrendDrawer from '../Trend';
import TrendProvider from '../Trend/TrendProvider';
import Consult from './Consult';
import convertData from './convertData';
import NonCODReminder from './NonCODReminder';
import Reminder from './Reminder';
import Purchase from './Purchase';
import { QuickChatControl } from 'components/QuickChatControl';

const Container = styled.div`
  margin-bottom: 16px;
`;

const initialValue = {
  storeInfo: {},
  dateRange: last7days(),
} as const;

const Content = () => {
  const { filter: filterCtx, hasTokopedia } = useDashboardFilterContext();
  const platform = platformAll2Undefined(filterCtx.platform);
  const fetchParams: Dashboard.BasicParams = useMemo(() => {
    const list = filterCtx.storeInfo.list || [];
    return {
      ...momentDateRange2FetchParams(filterCtx.dateRange),
      platform,
      storeType: storeType2FetchParams(filterCtx.storeType),
      storeIds: list.map((x) => x.id),
      departmentIds: filterCtx.departments?.map((_) => _.id),
    };
  }, [
    platform,
    filterCtx.dateRange,
    filterCtx.storeType,
    filterCtx.storeInfo.list,
    filterCtx.departments,
  ]);

  const { value, loading } = useAsync(() => {
    return getSaleConvert(fetchParams).then(convertData);
  }, [fetchParams]);

  return (
    <Spin spinning={loading}>
      <Container>
        <QuickChatControl>
          <Consult value={value} />
        </QuickChatControl>
        {filterCtx.platform !== 'TOKOPEDIA' && <Reminder value={value} />}
        {hasTokopedia && <Purchase value={value} />}
        {filterCtx.platform !== 'TOKOPEDIA' && <NonCODReminder value={value} />}
      </Container>
    </Spin>
  );
};

const SaleConvert = () => {
  return (
    <FilterProvider
      initialValue={initialValue}
      rightExtra={ExtraNode}
      dashboardName="SalesConversion"
      scene="ORDER_STAT"
      showPlatformAll
    >
      <TrendProvider>
        <Content />
        <TrendDrawer />
      </TrendProvider>
    </FilterProvider>
  );
};

export default SaleConvert;
